module.exports = new __parcel__URL__("campaignsLogo.74d01493.svg").toString();